module.exports = __webpack_public_path__ + "img/file-play-fill.73f00037.svg";